import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'ngx-registro-item2',
  templateUrl: './registro-item.component.html',
  styleUrls: ['./registro-item.component.scss']
})
export class RegistroItemComponent2 implements OnInit {


  @Input() public registro: any;
  @Input() public vUser: string;
  @Input() public vGroupUsers: any;

  public renderRegistro: any;

  ngOnInit(): void {
    this.renderRegistroItem();
  }
  async renderRegistroItem() {
    this.renderRegistro = {};
    if (this.vUser === this.registro.groupUserAdministrator) {
      const email = this.getGroupUserEmail(this.registro.userAuthor);
      this.renderRegistro.fieldNameWithoutParentheses = this.registro.recordData.parcelaName;
      this.renderRegistro.fieldNameParentheses = `(${email})`;
    } else {
      this.renderRegistro.fieldNameWithoutParentheses = this.registro.recordData.parcelaName;
      this.renderRegistro.fieldNameParentheses = '';
    }
    switch(this.registro.recordType){
      case 'TRATAMIENTO':
        this.renderRegistro.img = window.location.protocol+ '//' +window.location.host + "/assets/images/icTratamiento.png";

        this.renderRegistro.date = this.registro.recordData.fechaInicio + ' - ' + this.registro.recordData.fechaFin;
        this.renderRegistro.firstLine = this.registro.recordData.problematica.name;
        if(this.registro.recordData.tipoMedida.identifier == "1"){ //"Producto Fitosanitario"
          this.renderRegistro.secondLine = this.registro.recordData.productoMedida.datosProducto.nombre + " - " + this.registro.recordData.productoMedida.datosProducto.formulado;
        } else if(this.registro.recordData.tipoMedida.identifier == "2"){ //"Otros medios de defensa sanitaria"
          this.renderRegistro.secondLine = this.registro.recordData.productoMedida.name;
        }
        this.renderRegistro.thirdLine = "Dosis: " + this.registro.recordData.cantidad + " " + this.registro.recordData.unidad.name + ", Superficie: " + this.registro.recordData.superficie + " has.";
      break;
      case 'SIEMBRA':
        this.renderRegistro.img = window.location.protocol+ '//' +window.location.host + "/assets/images/icSiembra.png";
        this.renderRegistro.date = this.registro.recordData.fechaInicio + ' - ' + this.registro.recordData.fechaFin;
        this.renderRegistro.firstLine = this.registro.recordData.tipo.name + ' ' + this.registro.recordData.producto.name;
        if(this.registro.recordData.tipo.identifier == "1"){ //"Siembra"
          this.renderRegistro.secondLine = "Cantidad: " + this.registro.recordData.cantidad + " Kg, Sup.: " + this.registro.recordData.superficie + " has.";
        } else if(this.registro.recordData.tipo.identifier == "2"){ //"Plantación"
          this.renderRegistro.secondLine = this.registro.recordData.densidadPlantacion + " plantas/Ha, Sup.: " + this.registro.recordData.superficie + " has.";
        }
      break;
      case 'GEOFOTO':
        this.renderRegistro.img = window.location.protocol+ '//' +window.location.host + "/assets/images/icGeofoto.png";
        this.renderRegistro.date = moment(this.registro.timestamp.toDate()).format('DD/MM/YYYY HH:mm:ss');
        this.renderRegistro.firstLine = this.registro.recordData.tipo.name + ' ' + this.registro.recordData.uso;
        this.renderRegistro.secondLine = this.registro.recordData.observaciones;


      break;
      case 'COSECHA':
        this.renderRegistro.img = window.location.protocol+ '//' +window.location.host + "/assets/images/icCosecha.png";
        this.renderRegistro.date = this.registro.recordData.fechaInicio + ' - ' + this.registro.recordData.fechaFin;
        this.renderRegistro.firstLine = this.registro.recordData.tipo.name + ' ' + this.registro.recordData.producto.name;
        this.renderRegistro.secondLine = "Cantidad: " + this.registro.recordData.cantidad + " " + this.registro.recordData.unidad.name + ", Sup.: " + this.registro.recordData.superficie + " has.";
      break;
      case 'FERTILIZACION':
        this.renderRegistro.img = window.location.protocol+ '//' +window.location.host + "/assets/images/icFertilizacion.png";

        this.renderRegistro.date = this.registro.recordData.fechaInicio + ' - ' + this.registro.recordData.fechaFin;
        this.renderRegistro.firstLine = this.registro.recordData.tipoFertilizante.name;
        this.renderRegistro.secondLine = this.registro.recordData.productoFertilizante.name;

        this.renderRegistro.thirdLine = "Dosis: " + this.registro.recordData.dosis + " " + this.registro.recordData.unidad.name;
      break;
    }


    if(this.registro.syncCUE){
      switch(this.registro.syncCUE.status){
        case 'PENDING':
        case 'INIT':
        case 'PENDING_DELETE':
          this.renderRegistro.img_sync = window.location.protocol+ '//' +window.location.host + "/assets/images/ic_synccue_pending.png";
          this.renderRegistro.syncLineWarning = 'Pendiente';
          break;
        case 'ERROR':
            this.renderRegistro.img_sync = window.location.protocol+ '//' +window.location.host + "/assets/images/ic_synccue_error.png";
            this.renderRegistro.syncLineError =  this.registro.syncCUE.message;
          break;
          case 'SYNCED':
              this.renderRegistro.img_sync = window.location.protocol+ '//' +window.location.host + "/assets/images/ic_synccue_synced.png";
              break;
      }
    }
  }



  getGroupUserEmail(userOwnerId: string): string {
    const groupUser = this.vGroupUsers?.find(user => user.id === userOwnerId);
    return groupUser ? groupUser.email : '';
  }

}
